import React from 'react'
import { Field, Fields } from 'redux-form'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Card } from '../../../../component-library/components/card/card.component'
import { StyledHeading } from '../order-form.component.styles'
import { PackageContent } from './package-content/package-content.component'
import { Remarks } from './remarks/remarks.component'
import { PackageSizeAndWeight } from './package-size-and-weight/package-size-and-weight.component'
import { ConnectedPackagePhotoWithTranslation } from './package-photo/package-photo.component'
import { MerchantOrderNoteForm } from 'ggx-src/van-booking/order/sidebar/order-form/additional-requirements/merchant-order-note-form/merchant-order-note-form.component'

import { PackageSizeRadio } from './package-size-and-weight/package-size-radio.component.js'
import { PackageWeight } from './package-size-and-weight/package-weight.component.js'
import { PackageSize } from './package-size-and-weight/package-size.component.js'

const OrderDetailsForm = ({ dataTestid, size_option }) => {
  const [t] = useTranslation()

  return (
    <Card data-testid={dataTestid}>
      <StyledHeading>{t('common__package_details')}</StyledHeading>
      <PackageContent />
      <Fields
        names={['length', 'width', 'height', 'size_option']}
        component={PackageSizeRadio}
      />
      {size_option === 6 ? (
        <Fields
          names={['length', 'width', 'height', 'package_size_error']}
          component={PackageSize}
        />
      ) : null}

      <Fields names={['weight']} component={PackageWeight} />
      <Remarks />
      <MerchantOrderNoteForm name="merchant_order_number" />
      <Field
        name="image.secret"
        component={ConnectedPackagePhotoWithTranslation}
      />
    </Card>
  )
}

OrderDetailsForm.propTypes = {
  dataTestid: PropTypes.string,
}

export { OrderDetailsForm }
